import { createContext, useContext } from "react";

// Shared services a module panel can use, provided by ParentResult. A module
// loads its own data and publishes what the map should show through these —
// ParentResult never needs to know module-specific details.
//
//   language          current UI language code, e.g. "de"
//   showPoints(arr)   point markers (see normalizeToMapPoints) for map + list
//   showRoutes(arr)   line geometries (Themenrouten) for the map
//   activeOverlays    { [groupKey]: bool } — survives tab switches
//   toggleOverlay(k)  toggle an overlay layer (see overlayLayerRegistry)
//   selectItem(obj)   open an entry in the detail panel (see PoiInfoPanel)
//   selectedItem      entry currently open in the detail panel, or null
//   focusMap(point)   move the map to { latitude, longitude }
//   sideSlot          DOM node for the result list — use SideList.js
//   setHasSideList    used by SideList.js
//   setLoading(bool)  loading indicator for the result list
export const ModuleContext = createContext(null);

export function useModuleContext() {
  return useContext(ModuleContext);
}
